import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { FaCheckCircle, FaRegCalendarAlt } from "react-icons/fa";
import { FaArrowRight, FaCircleXmark } from "react-icons/fa6";
import { MdOutlineSend } from "react-icons/md";
import energoLogo from "../../../color-logo.svg";
import PrivateApi from "../../../services/PrivateApiService";
import EmployeeStage from "../../anlage/new_anlage/EmployeeStage";
import { useAuthState } from "../../../context/AuthContext";
import { useQueryClient } from "react-query";

const ChangePaymentModal = ({show, setShow, elv, wantedPayment}) => {

    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const { user, contactPerson } = useAuthState();
    const [apiError, setApiError] = useState("");
    const [view, setView] = useState("default");

    useEffect(() => {
        if (show === true && user.x_is_house_management && contactPerson === null) setView("hwContact");
    }, [show])

    const changePayment = () => {
        setView("loading");
        let data = {
            elv_id: elv.id,
            wanted: wantedPayment,
        }
        if (user.x_is_house_management) data['contact'] = contactPerson;

        API.post_Abrechnung_payment_type_change(data)
            .then(() => {
                queryClient.invalidateQueries("GET_ELV_DETAILS_QUERY");
                setView("done");
            })
            .catch(err => {
                setApiError(err?.response?.data?.detail || "Unbekannter Fehler ist aufgetreten, versuchen Sie später nochmal.");
                setView("error");
            });
    }

    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header className="bg-primary text-light">
                <div className="d-flex align-items-center gap-2">
                    <FaRegCalendarAlt size={30} />
                    <b>{wantedPayment}e Abrechnung aktivieren</b>
                </div>
            </Modal.Header>
            <Modal.Body>
                {view === "default" &&
                    <p>
                        <small className="text-muted">
                            Derzeit erfolgt Ihre Energieabrechnung {elv.x_monthly_invoice ? "monatlich" : "jährlich"}.
                            Wenn Sie dies auf {wantedPayment} ändern wollen, klicken Sie auf "{wantedPayment}e Abrechnung aktivieren".
                        </small>
                    </p>
                }
                {view === "loading" &&
                    <>
                        <div className="d-flex flex-column justify-content-center align-items-center gap-3">
                            <Spinner animation="border" className="text-primary" />
                            <p>Daten werden nach <b className="text-energo">ENERGO</b> übermittelt</p>
                        </div>
                    </>
                }
                {view === "done" &&
                    <>
                        <div className="d-flex justify-content-center align-items-center gap-4">
                            <FaRegCalendarAlt size={50} className="text-primary" />
                            <FaArrowRight size={30} />
                            <MdOutlineSend size={40} />
                            <FaArrowRight size={30} />
                            <div className="d-flex flex-column align-items-center">
                                <img src={energoLogo} alt="energo" width={70} />
                                <FaCheckCircle size={20} className="text-energo" />
                            </div>
                        </div>
                         <p className="mt-4 text-center">
                            Wir haben Ihre Anfrage bekommen und leiten sie zum Energielieferanten weiter.
                        </p>
                    </>
                }
                {view === "error" &&
                    <div className="text-center">
                        <h5 className="text-danger">Fehler passiert!</h5>
                        <div className="d-flex gap-4 align-items-center justify-content-center">
                            <FaRegCalendarAlt size={60} className="text-primary" />
                            <FaArrowRight size={30} />
                            <MdOutlineSend size={40} />
                            <FaArrowRight size={30} />
                            <FaCircleXmark size={50} className="text-danger" />
                        </div>
                        <p>{apiError}</p>
                    </div>
                }
                {view === "hwContact" &&
                    <EmployeeStage setStage={setView} setShow={setShow} />
                }
            </Modal.Body>
            <Modal.Footer hidden={view === "loading"}>
                {view === "default" &&
                    <div className="d-flex flex-end gap-3">
                        <Button onClick={() => setShow(false)} variant="warning">Abbrechen</Button>
                        <Button onClick={() => changePayment()} variant="primary">{wantedPayment}e Abrechnung aktivieren</Button>
                    </div>
                }
                {view === "done" &&
                    <Button onClick={() => setShow(false)} variant="energo">Schließen</Button>
                }
                {view === "error" &&
                    <Button onClick={() => setView("default")} variant="warning">Erneut versuchen</Button>
                }
            </Modal.Footer>
        </Modal>
    )
}
export default ChangePaymentModal;